/* BBV — Step "Confezione regalo" prima del checkout.
 * Drawer: il pannello si apre dentro <cart-drawer>. Pagina carrello: finestra modale.
 * Mostrato una volta per sessione e mai se nel carrello c'è già una busta.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('bbv-gift-step-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var SEEN_KEY = 'bbvGiftStepSeen';
  var MAX_QTY = 20;
  var S = CFG.strings;
  var ICONS = (function () {
    var t = document.getElementById('bbv-gift-icons'), o = { minus: '&minus;', plus: '+', prev: '&lsaquo;', next: '&rsaquo;' };
    if (t) t.content.querySelectorAll('[data-i]').forEach(function (n) { o[n.getAttribute('data-i')] = n.innerHTML; });
    return o;
  })();
  var root = CFG.root.replace(/\/?$/, '/');
  var products = {}; // handle -> product json (o null se non trovato)
  var loading = null;
  var giftVariantIds = {}; // variantId -> handle
  var changed = false;
  var panel = null;
  var pending = null; // { mode: 'drawer'|'page', href }

  function storage(fn) { try { return fn(window.sessionStorage); } catch (e) { return null; } }
  // per i test: aprendo una pagina con ?bbv_gift_reset lo step torna visibile in questa sessione
  if (/[?&]bbv_gift_reset/.test(window.location.search)) storage(function (s) { s.removeItem(SEEN_KEY); });
  function seen() { return storage(function (s) { return s.getItem(SEEN_KEY) === '1'; }); }
  function markSeen() { storage(function (s) { s.setItem(SEEN_KEY, '1'); }); }
  function track(name, data) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
  }

  function allHandles() {
    var h = [];
    CFG.groups.forEach(function (g) { g.items.forEach(function (i) { h.push(i.handle); }); });
    if (CFG.sticker && CFG.sticker.handle) h.push(CFG.sticker.handle);
    return h;
  }

  function loadProducts() {
    if (loading) return loading;
    loading = Promise.all(allHandles().map(function (handle) {
      return fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (p) {
          var v = p && p.variants && p.variants[0];
          products[handle] = (p && v && v.available) ? p : null;
          if (v) giftVariantIds[v.id] = handle;
        });
    }));
    return loading;
  }

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(CFG.locale, { style: 'currency', currency: CFG.currency }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- rendering ---------- */

  function cardHtml(item) {
    var p = products[item.handle];
    if (p === null) return ''; // non disponibile: non mostrare
    var v = p && p.variants[0];
    return '<div class="bbv-gift__card' + (p ? '' : ' is-loading') + '" data-handle="' + esc(item.handle) + '">' +
      '<div class="bbv-gift__img">' + (p && p.featured_image ? '<img src="' + esc(imgUrl(p.featured_image, 360)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
      '<div class="product-block__title bbv-gift__name">' + esc(item.name) + '</div>' +
      '<div class="small-text bbv-gift__size">' + esc(item.size) + '</div>' +
      '<div class="product-price product-price--block bbv-gift__price"><span class="price__current">' + (v ? esc(money(v.price)) : '&nbsp;') + '</span></div>' +
      (v ? actHtml(v.id) : '<button type="button" class="btn btn--secondary bbv-gift__add" disabled>' + esc(S.add) + '</button>') +
      '</div>';
  }

  function actHtml(id) {
    return '<div class="bbv-gift__act" data-variant="' + id + '" data-qty="0">' +
      '<button type="button" class="btn btn--secondary bbv-gift__add">' + esc(S.add) + '</button>' +
      '<div class="quantity buttoned-input buttoned-input--small bbv-gift__qty" hidden>' +
        '<a href="#" role="button" class="quantity-down bbv-gift__step" data-step="-1" aria-label="-">' + ICONS.minus + '</a>' +
        '<input type="number" class="bbv-gift__n" value="0" readonly tabindex="-1" aria-live="polite">' +
        '<a href="#" role="button" class="quantity-up bbv-gift__step" data-step="1" aria-label="+">' + ICONS.plus + '</a>' +
      '</div>' +
    '</div>';
  }

  function render() {
    var body = panel.querySelector('.bbv-gift__body');
    var html = '';
    CFG.groups.forEach(function (g) {
      var cards = g.items.map(cardHtml).join('');
      if (!cards) return;
      var n = g.items.filter(function (i) { return products[i.handle] !== null; }).length;
      var fixed = g.layout === 'fixed';
      html += '<div class="bbv-gift__group">' +
        '<div class="bbv-gift__group-head">' +
          '<p class="bbv-gift__group-title">' + esc(g.title) + (!fixed && n > 1 ? ' <span class="bbv-gift__count">· ' + n + ' ' + esc(S.models) + '</span>' : '') + '</p>' +
          '<div class="no-wrap slider-nav bbv-gift__nav" hidden>' +
            '<button type="button" class="slider-nav__btn has-ltr-icon bbv-gift__nav-btn" data-dir="-1" aria-label="' + esc(S.prev) + '">' + ICONS.prev + '</button>' +
            '<button type="button" class="slider-nav__btn has-ltr-icon bbv-gift__nav-btn" data-dir="1" aria-label="' + esc(S.next) + '">' + ICONS.next + '</button>' +
          '</div>' +
        '</div>' +
        '<div class="bbv-gift__row' + (fixed ? ' bbv-gift__row--fixed' : '') + '">' + cards + '</div></div>';
    });
    var st = CFG.sticker && products[CFG.sticker.handle];
    if (st) {
      html += '<div class="bbv-gift__sticker"><span>' + esc(S.sticker) + ' (' + esc(money(st.variants[0].price)) + ')</span>' +
        actHtml(st.variants[0].id) + '</div>';
    }
    body.innerHTML = html;
    initNav();
  }

  /* frecce del carosello: lo scorrimento a dito resta sempre attivo */
  function updateNav(row) {
    var nav = row.previousElementSibling && row.previousElementSibling.querySelector('.bbv-gift__nav');
    if (!nav) return;
    var max = row.scrollWidth - row.clientWidth;
    nav.hidden = max <= 4;
    var b = nav.querySelectorAll('.bbv-gift__nav-btn');
    b[0].disabled = row.scrollLeft <= 4;
    b[1].disabled = row.scrollLeft >= max - 4;
  }

  function initNav() {
    panel.querySelectorAll('.bbv-gift__row').forEach(function (row) {
      row.addEventListener('scroll', function () { updateNav(row); }, { passive: true });
      updateNav(row);
      row.querySelectorAll('img').forEach(function (img) { img.addEventListener('load', function () { updateNav(row); }); });
    });
  }

  function scrollRow(btn) {
    var row = btn.closest('.bbv-gift__group').querySelector('.bbv-gift__row');
    var card = row.querySelector('.bbv-gift__card');
    var step = card ? card.getBoundingClientRect().width + 12 : row.clientWidth * 0.8;
    var start = row.scrollLeft, target = start + Number(btn.getAttribute('data-dir')) * step;
    try { row.scrollTo({ left: target, behavior: 'smooth' }); } catch (e) { row.scrollLeft = target; }
    // alcuni browser ignorano lo scroll animato: in quel caso salta direttamente
    setTimeout(function () { if (Math.abs(row.scrollLeft - start) < 2) row.scrollLeft = target; updateNav(row); }, 450);
  }

  function syncFromCart(cart) {
    if (!panel) return;
    var inCart = {};
    (cart.items || []).forEach(function (it) {
      if (giftVariantIds[it.variant_id]) inCart[it.variant_id] = (inCart[it.variant_id] || 0) + it.quantity;
    });
    panel.querySelectorAll('.bbv-gift__act').forEach(function (act) {
      var q = inCart[act.getAttribute('data-variant')] || 0;
      act.setAttribute('data-qty', q);
      act.querySelector('.bbv-gift__add').hidden = q > 0;
      act.querySelector('.bbv-gift__qty').hidden = q === 0;
      act.querySelector('.bbv-gift__n').value = q;
    });
    var any = Object.keys(inCart).length > 0;
    panel.querySelector('.bbv-gift__go').textContent = any ? S.go : S.skip;
  }

  function buildPanel(mode) {
    var el = document.createElement('div');
    el.className = 'bbv-gift' + (mode === 'page' ? ' bbv-gift--modal' : '');
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'bbv-gift-title');
    el.innerHTML =
      '<div class="bbv-gift__box">' +
        '<div class="bbv-gift__head">' +
          '<button type="button" class="bbv-gift__back" aria-label="' + esc(S.back) + '">&larr;</button>' +
          '<h2 class="h4 heading-font bbv-gift__title" id="bbv-gift-title">' + esc(S.title) + '</h2>' +
        '</div>' +
        '<div class="bbv-gift__note">' + (ICONS.gift ? '<span class="bbv-gift__note-icon" aria-hidden="true">' + ICONS.gift + '</span>' : '') +
          '<p>' + (S.incLead ? '<strong>' + esc(S.incLead) + '</strong> ' : '') + esc(S.sub) + '</p></div>' +
        '<div class="bbv-gift__body"></div>' +
        '<div class="bbv-gift__foot">' +
          '<button type="button" class="btn btn--large btn--wide bbv-gift__go">' + esc(S.skip) + '</button>' +
          '<button type="button" class="link underline small-text bbv-gift__foot-back">' + esc(S.back) + '</button>' +
        '</div>' +
      '</div>';

    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('.bbv-gift__back') || t.closest('.bbv-gift__foot-back') || t === el && mode === 'page') { e.preventDefault(); close(); return; }
      if (t.closest('.bbv-gift__go')) { e.preventDefault(); proceed(); return; }
      var nb = t.closest('.bbv-gift__nav-btn');
      if (nb) { e.preventDefault(); scrollRow(nb); return; }
      var act = t.closest('.bbv-gift__act');
      if (!act || act.classList.contains('is-busy')) return;
      var q = Number(act.getAttribute('data-qty')) || 0;
      if (t.closest('.bbv-gift__add')) { e.preventDefault(); setQty(act, 1, q); }
      else if (t.closest('.bbv-gift__step')) { e.preventDefault(); setQty(act, Math.max(0, Math.min(MAX_QTY, q + Number(t.closest('.bbv-gift__step').getAttribute('data-step')))), q); }
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } });
    return el;
  }

  function setQty(act, qty, prev) {
    if (qty === prev) return;
    var id = Number(act.getAttribute('data-variant'));
    act.classList.add('is-busy');
    var json = { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } };
    var req = prev === 0
      ? fetch(root + 'cart/add.js', Object.assign({ body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) }, json))
      : fetch(root + 'cart/change.js', Object.assign({ body: JSON.stringify({ id: String(id), quantity: qty }) }, json));
    req.then(function () { changed = true; track('bbv_gift_qty', { gift_variant: id, gift_qty: qty }); return getCart(); })
      .then(syncFromCart)
      .catch(function () {})
      .then(function () { act.classList.remove('is-busy'); });
  }

  /* ---------- open / close / proceed ---------- */

  function open(mode, href) {
    pending = { mode: mode, href: href };
    changed = false;
    if (panel) panel.remove();
    panel = buildPanel(mode);
    var host = mode === 'drawer' ? document.querySelector('cart-drawer') : document.body;
    host.appendChild(panel);
    if (mode === 'drawer') {
      // lascia visibile l'intestazione del carrello (titolo + X): il pannello è la "seconda pagina" del drawer
      var head = host.querySelector('.cart-drawer__header');
      if (head) { panel.style.top = (head.getBoundingClientRect().bottom - host.getBoundingClientRect().top) + 'px'; panel.classList.add('bbv-gift--in-drawer'); }
    }
    if (mode === 'page') document.body.classList.add('overlay-is-open');
    window.addEventListener('resize', onResize);
    render();
    loadProducts().then(function () { render(); return getCart(); }).then(syncFromCart).catch(function () {});
    void panel.offsetWidth; // forza il reflow così la transizione parte anche senza rAF
    panel.classList.add('is-open');
    setTimeout(function () { var b = panel && panel.querySelector('.bbv-gift__back'); if (b) b.focus(); }, 320);
    markSeen();
    track('bbv_gift_step_view', { gift_step_mode: mode });
  }

  function onResize() {
    if (panel) panel.querySelectorAll('.bbv-gift__row').forEach(updateNav);
  }

  function close() {
    if (!panel) return;
    window.removeEventListener('resize', onResize);
    var p = panel, mode = pending && pending.mode;
    p.classList.remove('is-open');
    if (mode === 'page') document.body.classList.remove('overlay-is-open');
    setTimeout(function () { p.remove(); }, 320);
    panel = null;
    if (changed) {
      if (mode === 'drawer') {
        var f = document.querySelector('cart-drawer cart-form');
        if (f && typeof f.refresh === 'function') f.refresh();
      } else {
        window.location.reload();
      }
    }
  }

  function proceed() {
    var go = panel && panel.querySelector('.bbv-gift__go');
    if (go) go.disabled = true;
    track('bbv_gift_step_continue', { gift_added: go && go.textContent === S.go });
    window.location.href = (pending && pending.href) || (root + 'checkout');
  }

  /* ---------- intercept ---------- */

  function shouldShow() {
    if (seen()) return Promise.resolve(false);
    return Promise.all([getCart(), loadProducts()]).then(function (r) {
      var cart = r[0];
      if (!cart || !cart.item_count) return false;
      var hasGift = (cart.items || []).some(function (it) { return giftVariantIds[it.variant_id]; });
      var anyAvailable = Object.keys(products).some(function (h) { return products[h]; });
      return !hasGift && anyAvailable;
    }).catch(function () { return false; });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var drawerBtn = e.target.closest('cart-drawer .checkout-buttons a.btn');
    var pageBtn = !drawerBtn && e.target.closest('#update-cart[name="checkout"]');
    if (!drawerBtn && !pageBtn) return;
    if (seen()) return; // già visto in questa sessione: flusso normale

    e.preventDefault();
    e.stopImmediatePropagation();
    var mode = drawerBtn ? 'drawer' : 'page';
    var href = drawerBtn ? drawerBtn.getAttribute('href') : root + 'checkout';
    var trigger = drawerBtn || pageBtn;
    trigger.setAttribute('aria-busy', 'true');

    shouldShow().then(function (show) {
      trigger.removeAttribute('aria-busy');
      if (show) open(mode, href);
      else { markSeen(); window.location.href = href; }
    });
  }, true);

  // Precarica i prodotti quando si apre il drawer o si è sulla pagina carrello
  document.addEventListener('on:cart-drawer:before-open', function () {
    if (panel && pending && pending.mode === 'drawer') { panel.remove(); panel = null; }
    if (!seen()) loadProducts();
  }, true);
  if (/\/cart\/?$/.test(window.location.pathname) && !seen()) loadProducts();
})();
